module.exports = __webpack_public_path__ + "img/icone_interrogacao_branco.e22b89f9.svg";